// Orden de objeto usado para el grafico de estados
export const STATES = {
  DRAF: { id: 3, description: 'Borrador' },
  IN_PROGRESS: { id: 1, description: 'Creado' },
  JOINED: { id: 2, description: 'Ingresado' },
  IN_FLOW: { id: 6, description: 'En flujo' },
  APPROVED: { id: 12, description: 'Aprobado' },
  REJECTED: { id: 5, description: 'Rechazado' },
  MANAGED: { id: 10, description: 'Tramitado' },
  NUMBERED: { id: 70, description: 'Numerado' },
  FINISHED: { id: 9, description: 'Finalizado' },
  ARCHIVED: { id: 100, description: 'Archivado' },
  CANCELED: { id: 8, description: 'Anulado' }
};

export const getStates = () => STATES;

export const getStatesMap = () => {
  const states = getStates();
  // reduce object in id and descriptions
  return Object.keys(states).reduce((acc, key) => {
    acc[states[key].id] = states[key].description;
    return acc;
  }, {});
};
